import { withPreloadedJSON } from "@wss/hypernova";
import GlobalHeader from ".";

export const Header = withPreloadedJSON(GlobalHeader, "GlobalHeader");
